const TIMELINE_MOCK_ENDPOINT = '/mock-api/timeline-requests';

const buildSortMenu = (field) => ({
  type: 'sort',
  field,
  showSortButtonInHeader: false,
  options: [
    {
      label: 'Sort Ascending',
      icon: 'pi pi-arrow-up',
      order: 1,
    },
    {
      label: 'Sort Descending',
      icon: 'pi pi-arrow-down',
      order: -1,
    },
  ],
});

const buildMenuItems = (field, header) => [
  {
    label: header,
    items: [buildSortMenu(field, header)],
  },
];

const toFilterOption = (value) => {
  const normalizedValue = String(value ?? '').trim();
  return {
    id: normalizedValue,
    name: normalizedValue,
    label: normalizedValue,
    value: normalizedValue,
  };
};

const buildGlobalFilterMenuItems = (field, header, values = [], sortField, initialSelectedValues = []) => [
  {
    label: header,
    items: [
      buildSortMenu(sortField || field),
      {
        separator: true,
      },
      {
        type: 'filter',
        field,
        label: header,
        template: 'multiSelect',
        selectedValues: initialSelectedValues,
        options: values.map(toFilterOption),
        values: values.map(toFilterOption),
      },
    ],
  },
];

const FILTERABLE_COLUMNS = {
  approvers: 'Approver',
  projectName: 'Project Name',
  projectVertical: 'Project Vertical',
  requestStatus: 'Request Status',
};

const buildColumn = ({
  field,
  header,
  width,
  order,
  defaultPinned = false,
  sortable = true,
  filter = false,
  isGlobalFilter = false,
  align,
  className = '',
  headerClassName = '',
  sortField,
  filterField,
}) => ({
  field,
  header,
  width,
  minWidth: width,
  order,
  filter,
  isGlobalFilter,
  visible: true,
  sortable,
  pinnable: Boolean(defaultPinned),
  defaultPinned,
  showFilterButtonInHeader: false,
  showPinButtonInHeader: false,
  menuItems: sortable ? buildMenuItems(sortField || field, header) : [],
  sortField: sortField || field,
  filterField: filterField || field,
  ...(align ? { align, headerAlign: align } : {}),
  ...(className ? { className, bodyClassName: className } : {}),
  ...(headerClassName ? { headerClassName } : {}),
});

export const TIMELINE_TABLE_COLUMNS = [
  {
    field: 'srnNo',
    header: 'SRN #',
    width: 90,
    sortable: true,
    className: 'timeline-srn-column',
    headerClassName: 'timeline-srn-column',
    defaultPinned: true,
  },
  { field: 'projectName', header: 'Project Name', width: 115 },
  { field: 'projectVertical', header: 'Project Vertical', width: 110 },
  { field: 'requestedField', header: 'Requested field', width: 130 },
  { field: 'approvalLink', header: 'Approval Link', width: 135 },
  { field: 'oldDate', header: 'Old Date', width: 85 },
  { field: 'newDate', header: 'New Date', width: 85 },
  { field: 'reasonForChange', header: 'Reason for Change', width: 170 },
  {
    field: 'requestStatus',
    header: 'Request Status',
    width: 100,
    sortField: 'requestStatusRaw',
    filterField: 'requestStatusRaw',
  },
  { field: 'approvers', header: 'Approvers', width: 105 },
  { field: 'approvedBy', header: 'Approved By', width: 105 },
  { field: 'approvedDateTime', header: 'Approved Date & Time', width: 135 },
  { field: 'approverComment', header: "Approver's Comment", width: 170 },
  { field: 'requestedByName', header: 'Requested By', width: 105 },
  { field: 'requestedDateTime', header: 'Requested Date & Time', width: 140 },
  {
    field: 'action',
    header: 'Action',
    width: 55,
    sortable: false,
    className: 'timeline-action-column',
    headerClassName: 'timeline-action-column',
  },
];

export const buildTimelineTableColumns = (filterOptions = {}, initialSelectedValues = {}) => {
  return TIMELINE_TABLE_COLUMNS.map((column, index) => {
    const baseColumn = buildColumn({
      ...column,
      order: index + 1,
    });

    const filterLabel = FILTERABLE_COLUMNS[column.field];
    if (!filterLabel) {
      return baseColumn;
    }

    const filterField = column.filterField || column.field;
    const sortField = column.sortField || column.field;

    const filterValues = {
      approvers: filterOptions?.approver || [],
      projectName: filterOptions?.projectName || [],
      projectVertical: filterOptions?.projectVertical || [],
      requestStatus: filterOptions?.requestStatus || [],
      requestStatusRaw: filterOptions?.requestStatus || [],
    }[filterField] || [];

    // Pre-selected values for this field (e.g. the project entered from project details)
    const preSelected = initialSelectedValues[filterField] || initialSelectedValues[column.field] || [];

    return {
      ...baseColumn,
      filter: true,
      isGlobalFilter: true,
      filterVisible: false,
      showFilterButtonInHeader: false,
      menuItems: buildGlobalFilterMenuItems(filterField, filterLabel, filterValues, sortField, preSelected),
    };
  });
};

export default TIMELINE_MOCK_ENDPOINT;
